import api from '../../api/api'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllVehicles ({ commit }) {
    api.getVehicles(vehicle => {
      commit('setVehicle', vehicle)
    })
  },
  updateVehicle (context, vehicle) {
    api.updateVehicle(vehicle, function () {
      context.commit('getAllVehicles')
    })
  },
  delVehicle (context, vehicle) {
    api.deleteVehicle(vehicle, function () {
      context.commit('getAllVehicles')
    })
  },
  addVehicle (context, vehicle) {
    return api.addVehicle(vehicle, function (data) {
      context.commit('getAllVehicles')
    })
  }
}

const mutations = {
  getAllVehicles (state, options) {
    this.dispatch('getAllVehicles', options)
  },
  setVehicle (state, vehicles) {
    state.all = vehicles
  },
  updateVehicle (state, options) {
    this.dispatch('updateVehicle', options)
  },
  delVehicle (state, options) {
    this.dispatch('delVehicle', options)
  },
  addVehicle (state, options) {
    this.dispatch('addVehicle', options)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicle.js